import {
  Location,
} from 'history';
import {
  withRouter,
  RouteComponentProps,
} from 'react-router-dom';
import * as React from 'react';

export default function withRescroll<P> (getKey:(path:Location)=>string, Component: React.ComponentType<P & RouteComponentProps>) {
  return withRouter(class WithRescroll extends React.Component<P & RouteComponentProps> {
    private lastKey?:string = undefined;

    public render() {
      const currentKey = getKey(this.props.history.location);
      if (currentKey !== this.lastKey) {
        this.lastKey = currentKey;
        window.document.documentElement.scrollTop = 0;
      }
      return <Component {...this.props}/>
    }
  });
};



// WEBPACK FOOTER //
// ./src/shared/components/withRescroll.tsx